import { apiClient } from "./client";

// Backend [Flags]: Calendario=1, Destaque=2, Ambos=3
export const TipoNotificacao = {
  Calendario: 1,
  Destaque: 2,
  Ambos: 3,
};

export const listarEventos = () => apiClient.get("/eventos");

export const criarEvento = (payload) => apiClient.post("/eventos", payload);

export const editarEvento = (id, payload) =>
  apiClient.put(`/eventos/${id}`, payload);

export const excluirEvento = (id) => apiClient.delete(`/eventos/${id}`);

// Estado é por turma: o mesmo evento em turmas diferentes tem visto/lembrar
// independentes.
export const marcarCalendarioVisto = (id, turmaId) =>
  apiClient.post(`/eventos/${id}/turmas/${turmaId}/calendario-visto`);

// Calendário é reversível: desmarcar volta ao estado inicial.
export const desmarcarCalendarioVisto = (id, turmaId) =>
  apiClient.delete(`/eventos/${id}/turmas/${turmaId}/calendario-visto`);

export const marcarDestaqueVisto = (id, turmaId) =>
  apiClient.post(`/eventos/${id}/turmas/${turmaId}/destaque-visto`);

export const lembrarDepois = (id, turmaId) =>
  apiClient.post(`/eventos/${id}/turmas/${turmaId}/lembrar-depois`);

// Presença é por turma e reversível, igual ao visto do calendário.
export const confirmarPresenca = (id, turmaId) =>
  apiClient.post(`/eventos/${id}/turmas/${turmaId}/presenca`);

export const desconfirmarPresenca = (id, turmaId) =>
  apiClient.delete(`/eventos/${id}/turmas/${turmaId}/presenca`);

// Lista de confirmados agrupada por turma (só para quem gerencia o evento).
export const listarConfirmacoesPresenca = (id) =>
  apiClient.get(`/eventos/${id}/confirmacoes`);
